import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { Button, Checkbox, Drawer, Field, FileField, Input } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const New = ({ onClose, onSave, show }) => {
  const navigate = useNavigate();

  const [errors, setErrors] = useState([]);
  const [data, setData] = useState({
    name: '',
    is_agency_specific: false,
    is_default: false,
    logo: ''
  });

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleLogoChange = file => {
    setData({ ...data, logo: file });
  };

  const createCarrier = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      Api.createCarrier(data).then(({ data }) => {
        onSave();
        navigate(`${data.id}`);
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={createCarrier}>Create New Carrier</Button>}
      onClose={onClose}
      show={show}
      title='New Carrier'
    >
      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          value={data.name}
        />
      </Field>

      <Field label='Logo'>
        <FileField file={data.logo} onChange={handleLogoChange} />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_agency_specific}
          label='Agency specific carrier'
          onChange={handleCheckboxChange.bind(null, 'is_agency_specific')}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_default}
          label='Enabled by default on new products'
          onChange={handleCheckboxChange.bind(null, 'is_default')}
        />
      </Field>
    </Drawer>
  );
};

New.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default New;
